// extracted by mini-css-extract-plugin
export default {"closedDot":"closedDot--LbFBF"};